var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsPlatformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 3C6.64787 3 7.7 4.05213 7.7 5.35V6.4C7.7 7.44934 8.55066 8.3 9.6 8.3H10.65C11.9479 8.3 13 9.35213 13 10.65C13 11.9479 11.9479 13 10.65 13C9.35213 13 8.3 11.9479 8.3 10.65V9.6C8.3 8.55066 7.44934 7.7 6.4 7.7H5.35C4.05213 7.7 3 6.64787 3 5.35C3 4.05213 4.05213 3 5.35 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 5.35C12.6 6.42696 11.727 7.3 10.65 7.3C9.57304 7.3 8.7 6.42696 8.7 5.35C8.7 4.27304 9.57304 3.4 10.65 3.4C11.727 3.4 12.6 4.27304 12.6 5.35Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 12.6C6.42696 12.6 7.3 11.727 7.3 10.65C7.3 9.57304 6.42696 8.7 5.35 8.7C4.27304 8.7 3.4 9.57304 3.4 10.65C3.4 11.727 4.27304 12.6 5.35 12.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsPlatformIcon);
export default __webpack_public_path__ + "static/media/isPlatformIcon.e06bf967c85802fb673e0ed15d179fc2.svg";
export { ForwardRef as ReactComponent };